<div class="card-header map-card-header mb-1">
  <button appPopover 
    [popoverTitle]="'Map Key'" 
    [popoverTemplate]="popoverTemplate" 
    popoverPosition="left" class="btn btn-sm btn-dark-lt ml-auto">
      Map Key
  </button>
</div>
<div appSetHeight class="map">
  <div class="map-container">
    <div class="map-frame" #mapdiv>
      <div id="map"></div>
    </div>
  </div>
</div>

<ng-template #popoverTemplate>
  <ul class="list-unstyled">
    <li *ngFor="let type of locationTypesDisplay">
      <div class="pr-2">
        <div class="icon-circle icon-circle-xs map-legend dot" [ngStyle]="{'background-color': type.colour}"></div>
        {{ type.name }}
      </div>
    </li>
  </ul>
</ng-template>